import ProductSDU from 'components/Product/ProductSDU/ProductSDU';
import { withProductSDUProps } from 'viewModel/product/productSDU/withProductSDUProps';

export default withProductSDUProps(ProductSDU);
